import { createContext, RefObject } from 'react';
import type { ChatHandle } from '@crono-one/ai-chat';

// Context object lives in its own non-component module so its identity
// survives React Fast Refresh — a module mixing createContext() with
// components/hooks gets fully re-executed on hot reload, which would create
// a new context instance the already-mounted provider doesn't know about.

export interface SendMessageParams {
  message: string;
}

export interface ChatContextType {
  chatRef: RefObject<ChatHandle | null>;
  chatSidebarOpen: boolean;
  toggleChat: () => Promise<void>;
  openChat: () => Promise<void>;
  sendMessage: (params: SendMessageParams) => Promise<void>;
  setInputText: (text: string) => Promise<void>;
  subHasCoreAI: boolean | undefined;
}

export const ChatContext = createContext<ChatContextType | null>(null);
